import styled from 'styled-components';
import { Tab, TabList } from 'react-tabs';
import { TabListContainer, MainContainer, DefaultTab, PrimaryButton } from '../../../../components/shared/sharedStyles.styles';

export const Container = styled(MainContainer)`
  max-height: 68vh;
  padding-top: 0 !important;
  overflow-y: auto;
  overflow-x: hidden;

  @media(max-width: 800px){
    max-height: 100%;
    padding: 0.5rem;
    width: 100%;
    margin: 0;
  }
`;

export const ApplicantTab = styled.text`
  height: 1.5rem;
  padding: 0 0 !important;
  & > button {
    height: 100%;
    font-size: 11px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 0;
    background-color: transparent;
    outline: none;
    
  }
`;

export const SeeMoreTab = styled.button`
  color: black;
  background: none;
  color: none;
  border: none;
  float: initial;
  font-size: 20px;
  cursor: pointer;
  width: 28px;

  @media(max-width: 800px){
    display: none;
  }
  `

export const Title = styled.h5`
  font-size: 16px;
  text-transform: uppercase;
  color: ${props => props.theme.color_gray};
  font-weight: 400;
  padding: 0 1rem;

  @media(max-width: 800px){
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    padding: 0 .35rem;
    letter-spacing: .02em;
  }
`;

export const LineTitle = styled.hr`
  width: 100%;
  height: 1px;
  color: ${props => props.theme.color_gray};
`;

export const TabListSmallContainer = styled(TabListContainer)`
  top: 7.85rem;
`;

export const TabsContainer = styled.div`
  li.tab{
    display: inline-block;
    padding: .2rem .5rem .2rem .5rem;
    margin-bottom: 3px;
  }

  li{
    &:hover {
      border: 1px solid;
      border-color: ${props => {
        return(`
          ${props.theme['color_silver-chalice']}
          ${props.theme['color_silver-chalice']}
          ${props.theme.color_white}
          ${props.theme['color_silver-chalice']};
        `)
      }}
    }
  }

  li.active{
    background-color: ${props => props.theme.color_white};
    border: 1px solid ${props => props.theme['color_silver-chalice']};
    border-bottom: 0;
  }

  button{
    text-transform: uppercase;
    color: ${props => props.theme.color_gray};
    font-size: 1rem;
  }

  @media(max-width: 800px){
    display:none;
  }
`;

export const MobileTabsContainer = styled.div`
  position: sticky;
  top: 42px;
  right: 0;
  width: 100%;
  z-index: 20;
  padding: 8px 10px 9px;
  background: linear-gradient(180deg, #ffffff 0%, #f4f8ff 100%);
  border-bottom: 1px solid rgba(21, 43, 78, 0.1);
  box-shadow: 0 4px 14px rgba(21, 43, 78, 0.08);

  .mobile-tab-list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: thin;
  }

  .mobile-tab {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 34px;
    min-width: 0;
    max-width: min(340px, 88vw);
    border-radius: 999px;
    border: 1px solid rgba(21, 43, 78, 0.17);
    background: #fff;
    color: #152b4e;
    font-size: 11px;
    font-weight: 600;
    padding: 0 12px 0 12px;
    overflow: hidden;
    box-sizing: border-box;
    transition: all 0.16s ease;
  }

  .mobile-tab-start {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
  }

  .mobile-tab-label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mobile-tab-suffix {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }

  .mobile-tab.active {
    border-color: #1f3f71;
    background: linear-gradient(180deg, #1f3f71 0%, #16355f 100%);
    color: #fff;
    box-shadow: 0 3px 10px rgba(21, 43, 78, 0.22);
  }

  .mobile-tab svg {
    width: 12px;
    height: 12px;
  }

  .mobile-tab.active svg path {
    fill: #ffffff;
  }

  @media(min-width: 801px){
    display:none;
  }
`;

export const TabSmall = styled(Tab)`
  & > button {
    text-transform: unset;
    font-size: .9rem;
  }
`;

export const BottomButton = styled(PrimaryButton)`
  height: 40px;

  @media(max-width: 800px){
    width: 100%;
    max-width: 260px;
    padding: 0.375rem 1.1rem;
    transform: scale(1);
    border-radius: 10px;
    font-weight: 600;
    font-size: .88rem;
    box-shadow: 0 2px 10px rgba(21, 43, 78, 0.22);
  }
`;

export const TabListContainerRequest = styled(TabList)`
  margin-bottom: 0;
  padding-left: 0;
  width: calc(100% - 28px - 28px);

  @media(max-width: 800px){
    margin-top: 0;
  }
`;